import { useCountryAndUnitOptions } from '@/app/components/AutoDeduction/useCountryAndUnitOptions';
import { ReportingGroupType } from '@/app/components/TimeReporting/components/TimeSheet/data';
import { useReportingTypeOptions } from '@/app/components/AutoDeduction/useReportingTypeOptions';
import { SelectOptionProps } from '@/app/components/AutoDeduction/types';

// Helper function to extract options from reporting types
const extractOptions = (
  reportingTypesOptions: any[],
  includeEmpty?: boolean,
): SelectOptionProps[] => {
  const options = reportingTypesOptions.length
    ? reportingTypesOptions[0].options
    : [];
  const empty = { label: '', value: '' };
  return includeEmpty ? [empty, ...options] : options;
};

export const useAutoDeductionOptions = () => {
  const { unitOptions, countryOptions } = useCountryAndUnitOptions();

  const { reportingTypesOptions: correctionTypes } = useReportingTypeOptions(
    [ReportingGroupType.TIMESHEET_CORRECTION_TYPE],
    null,
    false,
  );
  const { reportingTypesOptions: nonWorkTypes } = useReportingTypeOptions(
    [ReportingGroupType.TIMESHEET_NON_WORK_TYPE],
    null,
    false,
  );

  const correctionTypeOptions = extractOptions(correctionTypes, false);
  const nonWorkTypeOptions = extractOptions(nonWorkTypes, false);

  return {
    unitOptions,
    countryOptions,
    correctionTypeOptions,
    nonWorkTypeOptions,
  };
};
